
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/faq",
    icon: "android-menu",
    name: "FAQ",
    title: "F.A.Q",
    component: Main,
    children: [
      {
        path: "index",
        title: "F.A.Q分类配置",
        name: "FAQCategory",
        component: resolve => {
          require(["@/views/faq/faq.vue"], resolve);
        }
      },
      {
        path: "questionDetail/:id",
        title: "分类问题列表",
        name: "FAQQuestion",
        component: resolve => {
          require(["@/views/faq/question.vue"], resolve);
        }
      },
      {
        path: "question/create/:cid",
        title: "创建问题",
        name: "FAQQuestionCreate",
        component: resolve => {
          require(["@/views/faq/question-form.vue"], resolve);
        }
      },
      {
        path: "question/:cid/:id",
        title: "编辑问题",
        name: "FAQQuestionEdit",
        component: resolve => {
          require(["@/views/faq/question-form.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
